<script setup>
import { RouterLink } from "vue-router";
import { BRAND_LOGO_URL } from "@/shared/config/constants";
import AccountMenu from "@/components/layout/AccountMenu.vue";

defineProps({
  loginRedirect: { type: String, default: "/tokenomics" },
  variant: { type: String, default: "default" },
});
</script>

<template>
  <header class="topbar" :class="{ static: variant === 'approval' }">
    <RouterLink class="brand" :to="{ name: 'leaderboard' }">
      <img :src="BRAND_LOGO_URL" alt="做中学熊" />
      <span>小能熊 · token 排行榜</span>
    </RouterLink>
    <nav v-if="variant === 'approval'">
      <RouterLink class="topbar-link back-link" :to="{ name: 'leaderboard' }">返回排行榜</RouterLink>
    </nav>
    <nav v-else>
      <RouterLink class="topbar-link" :to="{ name: 'settings' }">设置</RouterLink>
      <RouterLink class="topbar-link" :to="{ name: 'changelog' }">更新日志</RouterLink>
      <AccountMenu :login-redirect="loginRedirect" />
    </nav>
  </header>
</template>
